<template>
  <div class="recursos-operacao-map-controls-overlay">
    <v-tooltip
      v-for="item in items"
      :key="item.id"
      right
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :color="item.active ? 'warning' : (item.color || 'primary')"
          :disabled="item.disabled"
          dark
          fab
          x-small
          class="ma-0"
          v-bind="attrs"
          v-on="on"
          @click="$emit('select', item.id)"
        >
          <v-icon dark color="white" small>{{ item.icon }}</v-icon>
        </v-btn>
      </template>
      <span>{{ item.label }}</span>
    </v-tooltip>

    <v-menu
      v-if="menuItems && menuItems.length"
      offset-x
      right
      nudge-right="8"
    >
      <template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
        <v-tooltip right>
          <template v-slot:activator="{ on: tipOn, attrs: tipAttrs }">
            <v-btn
              color="primary"
              dark
              fab
              x-small
              class="ma-0"
              v-bind="{ ...menuAttrs, ...tipAttrs }"
              v-on="{ ...menuOn, ...tipOn }"
            >
              <v-icon dark color="white" small>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <span>{{ actionsLabel }}</span>
        </v-tooltip>
      </template>
      <v-list dense>
        <v-list-item
          v-for="item in menuItems"
          :key="item.id"
          :disabled="item.disabled"
          @click="$emit('select', item.id)"
        >
          <v-list-item-icon class="mr-2">
            <v-icon small :color="item.active ? 'warning' : undefined">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title :class="{ 'warning--text': item.active }">{{ item.label }}</v-list-item-title>
          <v-list-item-action v-if="item.active">
            <v-icon small color="warning">mdi-check</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "RecursosOperacaoMapControls",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    menuItems: {
      type: Array,
      default: () => [],
    },
    actionsLabel: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.recursos-operacao-map-controls-overlay {
  position: absolute;
  z-index: 1100;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  top: calc(10px + 76px);
  left: 23px;
  max-height: calc(100% - 10px - 76px - 12px);
}
.recursos-operacao-map-controls-overlay > * {
  pointer-events: auto;
}
</style>
